module.exports = __webpack_public_path__ + "img/lg_ring_y_s_0_0@3x.fbcff75c.png";